module.exports = __webpack_public_path__ + "static/media/Element_Dendro.a12eab81.png";